import { forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

/**
 * Adapter that maps MUI's `href` prop to React Router's `to` prop,
 * allowing MUI Link and ButtonBase-derived components to use React Router
 * navigation automatically via theme-level defaultProps.
 */
const LinkBehavior = forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;
  return <RouterLink ref={ref} to={href} {...other} />;
});

LinkBehavior.displayName = 'LinkBehavior';

export default LinkBehavior;
